import React, { useEffect, useRef } from 'react';
import { Sprout, Sun, Scissors, Flower2 } from 'lucide-react';
import { useReveal, JoinFull, InstagramSection, FAQ } from '../components/shared';
import { TUBERS, FAQ_TUBERS, CARE_GUIDE } from '../mock';

const CARE_ICONS = { sprout: Sprout, sun: Sun, scissors: Scissors, flower: Flower2 };

export default function Tubers({ scrollToJoin }) {
  useReveal([]);
  const joinRef = useRef(null);

  useEffect(() => {
    if (scrollToJoin) {
      setTimeout(() => joinRef.current && joinRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' }), 150);
    }
  }, [scrollToJoin]);

  return (
    <div className="page active">
      <div className="page-header">
        <span className="page-header-eyebrow">Torquay Flower Farm · Surf Coast Victoria</span>
        <span className="page-header-title">Growing blooms with<i>a whole lotta love</i><em>For the dahlia obsessed</em></span>
        <button className="page-header-cta" onClick={() => joinRef.current && joinRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })}>Join Our Community</button>
      </div>

      <div className="tg-wrap"><div className="tg">
        {TUBERS.map((t, i) => (
          <article className="tc rev" key={t.name}>
            <div className="tc-iw">
              <div className="tc-img bg-photo" style={{ backgroundImage: `url(${t.img})` }} />
            </div>
            <h2 className="tc-name-s">{t.name}</h2>
            <div className="tc-price-s">{t.price}</div>
            <button className="tc-soon-btn" onClick={() => joinRef.current && joinRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })}>Join the Waitlist</button>
          </article>
        ))}
      </div></div>

      <FAQ items={FAQ_TUBERS} />

      <div className="bulk">
        <div>
          <span style={{ fontSize: 9, fontWeight: 600, letterSpacing: 4, textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', display: 'block', marginBottom: 8 }}>Wholesale &amp; Bulk</span>
          <h3 className="bulk-h">Buying dahlia tubers in bulk?</h3>
          <p className="bulk-p">We offer wholesale pricing for florists, market gardeners and growers buying 10+ tubers of a single variety. Ships Australia-wide (excluding TAS &amp; WA).</p>
        </div>
        <button className="btn" style={{ background: 'var(--white)', color: 'var(--forest)', whiteSpace: 'nowrap' }}>Enquire About Bulk Tubers</button>
      </div>

      <div className="care-wrap">
        <span className="eyebrow eyebrow-forest rev">Growing guide</span>
        <h2 className="rev serif-h" style={{ marginTop: 8 }}>How to grow dahlia tubers</h2>
        <div className="care-grid">
          {CARE_GUIDE.map((c, i) => {
            const Ic = CARE_ICONS[c.icon] || Flower2;
            return (
              <div className="cc rev" key={i}><span className="cc-icon"><Ic size={26} strokeWidth={1.6} color="#5B6650" /></span><div className="cc-title">{c.title}</div><p className="cc-body">{c.body}</p></div>
            );
          })}
        </div>
      </div>

      <div ref={joinRef}>
        <JoinFull eyebrow="Inaugural Dahlia Sale · September 2027" headline="First dibs on dahlias.<br>Make sure you're on the list." body="We sell to our community first — before the public, before it sells out." />
      </div>

      <InstagramSection />

      <div className="seo-intro">
        <div className="seo-inner">
          <h1 className="seo-h">Dahlia Tubers for Sale<br /><em style={{ fontStyle: 'italic', fontWeight: 300 }}>Surf Coast Grown</em></h1>
          <p className="seo-p">Looking to <strong>buy dahlia tubers in Australia</strong>? Torquay Flower Farm grows <strong>dahlia tubers for sale</strong> on Victoria's Surf Coast. Our inaugural <strong>dahlia tuber sale opens September 2027</strong>, with early access for our community list. We also offer <strong>dahlia tubers in bulk</strong> for florists and wholesale buyers. Every tuber is hand-dug, inspected and stored correctly — <strong>grown by us, on this farm</strong>. <strong>Buy dahlia tubers online</strong> and we'll ship Australia-wide (excluding TAS and WA), or collect from Torquay.</p>
        </div>
      </div>
    </div>
  );
}
